/* eslint-disable curly */
/* eslint-disable quotes */
/* eslint-disable no-unwrapped-jsx/no-unwrapped-jsx-text */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { ReactComponent as WarningIcon } from 'Assets/svg/warning-icon-2.svg';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';
import { ReactComponent as TickIcon } from 'Assets/svg/bg-tick.svg';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { HocPopupComponent } from 'Components/common/hocPopupComponent';
import CheckBox from 'Components/common/CheckBoxNew';
import Button from 'Components/common/Button';
import { LoadingWrapper } from 'Components/common/loadingWrapper';
import FeatureLockedTooltip from 'Components/common/FeatureLockedTooltip';
import { commonUpgradePopupState } from 'Components/common/commonUpgradePopup';
import ToolTipWithIcon from 'Components/common/ToolTipWithIcon';
import SharedListIcon from 'Components/common/SharedListIcon';
import { userDetail } from 'Stores/userDetail';
import { advSearchState } from 'Stores/advSearch';
import {
  MOBILE_NUMBER_EVENTS,
  PAGE_PATH_MAP,
  TOAST_MSG_TYPES,
  UPGRADE_TRIGGERS,
} from 'Utils/constants';
import { Utils } from 'Utils/utils';
import './styles.scss';
import { toasterState } from 'Components/common/toaster';
import myLeadsState from 'Stores/myLeads';

const POPUP_STEP = {
  LIST_SELECTION_OR_CREATION: 'LIST_SELECTION_OR_CREATION',
  ADD_TO_LIST: 'ADD_TO_LIST',
};

const defaultOptions = {
  isEmailMandatory: false,
  saveAction: null,
  isSingleContactAddToList: false,
};

class AddToListWithOptionsState {
  @observable showPopup = false;

  @observable popupStep = POPUP_STEP.LIST_SELECTION_OR_CREATION;

  @observable addToListData = {};

  @observable newList = false;

  addToListOptions = defaultOptions;

  setAddToListOptions = data => {
    this.addToListOptions = {
      ...this.addToListOptions,
      ...data,
    };
  };

  setIsNewList(value) {
    this.newList = value;
  }

  setPopupStep(value) {
    this.popupStep = value;
  }

  setAddToListData(data = {}) {
    this.addToListData = data;
  }

  setShowListPopup(show) {
    if (!show) this.setPopupStep(POPUP_STEP.LIST_SELECTION_OR_CREATION);
    this.showPopup = show;
  }

  handleAddToList = async data => {
    const { addToListCallback, listId, checkboxValues } = data;

    await advSearchState.purchaseContactAsync(
      {
        listId,
        required: advSearchState.getRequiredPropertyForPurchase(checkboxValues),
      },
      this.newList,
    );
    addToListCallback();
  };
}

const addToListWithOptionsState = new AddToListWithOptionsState();

const AddToListWithOptions = observer(() => {
  const [listName, setListName] = useState('');
  const [checkboxValues, setCheckboxValues] = useState({
    email: true,
    phone: false,
    phoneOrEmail: false,
  });
  const [listId, setListId] = useState('');
  const [createListloading, setCreateListLoading] = useState(false);
  const [addToListloading, setAddToListLoading] = useState(false);
  const [listType, setListType] = React.useState('private');

  const matchedList = userDetail.myLeadList.filter(list => {
    const reg = new RegExp(listName, 'i');
    return list.name.match(reg) && list.id;
  });

  const resetModalData = () => {
    setListName('');
    setListId('');
    setListType('private');
    setCheckboxValues({
      email: true,
      phone: false,
      phoneOrEmail: false,
    });
    addToListWithOptionsState.setIsNewList(false);
    addToListWithOptionsState.setAddToListData({});
    addToListWithOptionsState.setAddToListOptions(defaultOptions);
  };

  const addToListCallback = () => {
    setAddToListLoading(false);
    const { callback } = addToListWithOptionsState.addToListData;
    addToListWithOptionsState.setShowListPopup(false);

    if (callback)
      callback({
        listId,
        listName: userDetail.myLeadList.find(list => list.id === listId)?.name,
      });

    resetModalData();
  };

  const handleCloseClick = () => {
    resetModalData();
    addToListWithOptionsState.setShowListPopup(false);
  };

  const selectedCount =
    advSearchState.bulkRangeCount > 0
      ? advSearchState.bulkRangeCount
      : advSearchState.bulkPurchaseIds.length;

  const {
    availableEmailCredits = userDetail.userInfo.lbCredits,
    availablePhoneCredits = userDetail.userInfo.phoneCreditsRemaining,
  } = addToListWithOptionsState.addToListData;

  const handleSelectList = (e, selectedListId) => {
    if (listId === selectedListId) {
      setListId('');
    } else {
      setListId(selectedListId);
      addToListWithOptionsState.setIsNewList(false);
    }
  };

  const handleSelectedListClear = () => {
    resetModalData();
    addToListWithOptionsState.setPopupStep(
      POPUP_STEP.LIST_SELECTION_OR_CREATION,
    );
  };

  const handleContainCheckBoxChanges = (data = {}) => {
    setCheckboxValues(data);
    addToListWithOptionsState.setAddToListData({});
  };

  const trigerAddToListCallback = (newListId = null) => {
    const selectedListId = newListId || listId;
    if (addToListWithOptionsState.addToListOptions.saveAction) {
      addToListWithOptionsState.addToListOptions.saveAction({
        listId: selectedListId,
        listName: userDetail.myLeadList.find(list => list.id === selectedListId)
          ?.name,
        callback: addToListCallback,
        checkboxValues,
      });
    } else {
      addToListWithOptionsState.handleAddToList({
        listId: selectedListId,
        listName,
        checkboxValues,
        addToListCallback,
      });
    }
  };

  const creditCheckCallback = async data => {
    // also checking in member CRM preferences as disconnection may not remove in team
    if (
      checkboxValues.email &&
      !addToListWithOptionsState.addToListOptions.isSingleContactAddToList &&
      userDetail.userInfo?.teamCRMPreferences?.SALESFORCE
        ?.dont_purchase_if_present_in_crm &&
      userDetail.userInfo.crmPreferences?.SALESFORCE?.connected
    ) {
      const isValid = await advSearchState.checkSFAuth();
      if (!isValid) {
        addToListCallback();
        advSearchState.clearAllSelection(true);
        advSearchState.showSalesforceAuthError = true;
        return;
      }
    }

    if (addToListWithOptionsState.newList && !data?.lessCredits) {
      setCreateListLoading(true);
      const isSharedList = Utils.isSharedList(listType);
      const callback = response => {
        const id = response?.data?.id;
        if (id) {
          userDetail.addNewListToMyList({
            id,
            name: listName,
            isSharedList,
          });
          toasterState.setToastMsg('List created successfully', 'SUCCESS-NEW');
          setListId(id);
          trigerAddToListCallback(id);
        } else {
          handleSelectedListClear();
        }
      };

      const response = await myLeadsState.createList({
        name: listName,
        isSharedList,
      });
      setCreateListLoading(false);
      if (response?.data?.id) {
        callback(response);
      } else {
        setAddToListLoading(false);
      }
    } else {
      trigerAddToListCallback();
    }
  };

  const handleSaveClick = async () => {
    if (checkboxValues.email || checkboxValues.phone) {
      setAddToListLoading(true);
      if (!addToListloading)
        if (Utils.isPaygPlan() || Utils.isFreeTrialPlan()) {
          await Utils.checkUserHasEnoughCredits(
            selectedCount,
            'add to list',
            data => {
              if (data?.lessCredits) {
                addToListWithOptionsState.addToListData = {
                  ...addToListWithOptionsState.addToListData,
                  showBuyMoreCreditsWarning: true,
                  availableEmailCredits: data.availableEmailCredits,
                  availablePhoneCredits: data.availablePhoneCredits,
                };
                setAddToListLoading(false);
              } else {
                creditCheckCallback();
              }
            },
            checkboxValues.email && checkboxValues.phone
              ? 'all'
              : checkboxValues.phone
              ? 'phone'
              : 'email',
          );
        } else if (Utils.isLBPaidSubscription()) {
          const isEnoughCreditsNotAvailable =
            checkboxValues.email && checkboxValues.phone
              ? selectedCount > userDetail.userInfo.phoneCreditsRemaining ||
                selectedCount > userDetail.userInfo.lbCredits
              : checkboxValues.email
              ? selectedCount > userDetail.userInfo.lbCredits
              : checkboxValues.phone
              ? selectedCount > userDetail.userInfo.phoneCreditsRemaining
              : '';
          if (isEnoughCreditsNotAvailable) {
            addToListWithOptionsState.addToListData = {
              ...addToListWithOptionsState.addToListData,
              showNotEnoughCreditsWarning: true,
            };
            setAddToListLoading(false);
          } else {
            creditCheckCallback();
          }
        } else {
          creditCheckCallback();
        }
    } else {
      toasterState.setToastMsg(
        'Select one of email or mobile number',
        TOAST_MSG_TYPES.FAILURE,
      );
    }
  };

  const handleNextClick = () => {
    if (
      addToListWithOptionsState.addToListOptions.isSingleContactAddToList &&
      listId
    ) {
      handleSaveClick();
    } else {
      addToListWithOptionsState.setPopupStep(POPUP_STEP.ADD_TO_LIST);
      if (!addToListWithOptionsState.newList)
        setListName(
          userDetail.myLeadList.find(list => list.id === listId)?.name,
        );
    }
  };

  return (
    addToListWithOptionsState.showPopup && (
      <HocPopupComponent
        showCloseIcon
        allowMaskClick={!createListloading}
        customClassName="list-popup"
        closeClick={() => handleCloseClick()}
      >
        <LoadingWrapper show={createListloading} position="absolute" />
        <div className="modal-header">Add to list</div>
        <div className="popup-body">
          {addToListWithOptionsState.popupStep ===
          POPUP_STEP.LIST_SELECTION_OR_CREATION ? (
            <div className="modal-body">
              <label htmlFor="enter-list" onClick={e => e.preventDefault()}>
                List name
              </label>
              <div className="input-wrapper">
                {addToListWithOptionsState.newList && listName ? (
                  <div className="selected-value-wrapper">
                    <div className="selected-value">{listName}</div>
                    <CloseIcon onClick={e => handleSelectedListClear(e)} />
                  </div>
                ) : (
                  <input
                    id="enter-list"
                    placeholder="Enter or create lists..."
                    value={listName}
                    onChange={e => {
                      setListName(e.target.value);
                      addToListWithOptionsState.setIsNewList(false);
                    }}
                  />
                )}

                {listName &&
                  !addToListWithOptionsState.newList &&
                  !userDetail.myLeadList.some(
                    list => list.name === listName,
                  ) && (
                    <div className="input-suggestion">
                      <div
                        className="list create-new"
                        onClick={() => {
                          if (listName) {
                            setListId('');
                            addToListWithOptionsState.setIsNewList(true);
                          }
                        }}
                      >
                        {`+ Create new list named "${listName}"`}
                      </div>
                    </div>
                  )}
                <div className="matching-suggestion">
                  {matchedList.map(list => {
                    return (
                      <div
                        className={`list ${
                          list.id === listId ? 'selected' : ''
                        }`}
                        key={list.Id}
                        onMouseDown={e => handleSelectList(e, list.id)}
                      >
                        <div className="list-name">{list.name}&nbsp;</div>
                        <div className="list-count">
                          {list.count > 0 ? (
                            <>
                              ({Utils.numberFormat(list.count)}&nbsp;
                              {list.count > 1 ? 'contacts' : 'contact'})
                            </>
                          ) : (
                            ''
                          )}
                        </div>
                        <SharedListIcon data={list} />
                        <TickIcon className="tick-icon" />
                      </div>
                    );
                  })}
                </div>
                <div className="button-wrapper">
                  <Button
                    btnText="Cancel"
                    className="cancel-btn"
                    click={() => handleCloseClick()}
                  />
                  <Button
                    className="save-btn"
                    loader={
                      addToListWithOptionsState.addToListOptions
                        .isSingleContactAddToList && addToListloading
                    }
                    btnText={
                      addToListWithOptionsState.addToListOptions
                        .isSingleContactAddToList && listId
                        ? 'Save'
                        : 'Next'
                    }
                    disabled={
                      !(
                        listId ||
                        (listName !== '' && addToListWithOptionsState.newList)
                      )
                    }
                    click={e => handleNextClick()}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="modal-body">
              <label htmlFor="enter-list" onClick={e => e.preventDefault()}>
                List name
              </label>
              <div className="input-wrapper">
                <div className="selected-value-wrapper">
                  <div className="selected-value">{listName}</div>
                  <CloseIcon onClick={e => handleSelectedListClear(e)} />
                </div>
                {addToListWithOptionsState.newList &&
                  Utils.isSharedListEnabled() && (
                    <div className="share-list-option-wrapper">
                      <CheckBox
                        label="Share your list with the team"
                        isChecked={listType === 'shared'}
                        onClick={() =>
                          setListType(
                            listType === 'private' ? 'shared' : 'private',
                          )
                        }
                      />
                    </div>
                  )}
              </div>
              {!addToListWithOptionsState.addToListOptions
                .isSingleContactAddToList && (
                <div className="purchase-checkbox-wrapper">
                  <span className="checkbox-label">Must contain</span>

                  <CheckBox
                    className="email-checkbox"
                    label={
                      addToListWithOptionsState.addToListOptions
                        .isEmailMandatory ? (
                        <>
                          Business Email
                          <ToolTipWithIcon>Email is mandatory</ToolTipWithIcon>
                        </>
                      ) : (
                        <>Business Email</>
                      )
                    }
                    isChecked={checkboxValues.email}
                    onClick={() => {
                      if (
                        !addToListWithOptionsState.addToListOptions
                          .isEmailMandatory
                      ) {
                        const newValue = !checkboxValues.email;

                        handleContainCheckBoxChanges({
                          ...checkboxValues,
                          email: newValue,
                        });
                      }
                    }}
                  />
                  {Utils.isLBPaidSubscription() &&
                  !userDetail.userInfo.phoneVendorPurchaseEnabled ? (
                    <FeatureLockedTooltip
                      callback={() => {
                        Utils.mixpanelTrack(
                          MOBILE_NUMBER_EVENTS.MOBILE_NUMBER_UPGRADE_POPUP_SHOWN,
                        );
                      }}
                      featureEnabled={
                        userDetail.userInfo.phoneVendorPurchaseEnabled
                      }
                      iconContent={
                        <div className="lock-wrap">
                          <CheckBox
                            label={<>Mobile Number</>}
                            isChecked={checkboxValues.phone}
                          />
                          <div className="lock-wrapper">
                            <LockIcon />
                          </div>
                        </div>
                      }
                      className="mobile-number-locked"
                    >
                      Mobile Numbers are not available in your current plan.
                      Please upgrade your plan to get access.
                      <button
                        type="button"
                        onClick={() => {
                          advSearchState.notifyMobileNumberInterest();
                          window.open(PAGE_PATH_MAP.PRICING, '_blank');
                        }}
                      >
                        Upgrade Now
                      </button>
                    </FeatureLockedTooltip>
                  ) : (
                    <CheckBox
                      label={<>Mobile Numbers</>}
                      isChecked={checkboxValues.phone}
                      onClick={() => {
                        if (
                          Utils.isPaidSubscription() ||
                          (Utils.isEnterpriseFreeTrialPlan() &&
                            userDetail.userInfo.phoneVendorPurchaseEnabled)
                        ) {
                          const newValue = !checkboxValues.phone;
                          const newValueForOr =
                            newValue || checkboxValues.email
                              ? false
                              : checkboxValues.phoneOrEmail;
                          handleContainCheckBoxChanges({
                            ...checkboxValues,
                            phone: newValue,
                            phoneOrEmail: newValueForOr,
                          });
                        } else {
                          Utils.mixpanelTrack(
                            MOBILE_NUMBER_EVENTS.MOBILE_NUMBER_UPGRADE_POPUP_SHOWN,
                            {
                              source: 'Add to List',
                            },
                          );
                          commonUpgradePopupState.setShowUpgradePopup(
                            UPGRADE_TRIGGERS.PURCHASE_PHONE,
                          );
                        }
                      }}
                    />
                  )}
                </div>
              )}
              {/* <CheckBox
                label="Business Email OR Mobile Numbers"
                isChecked={checkboxValues.phoneOrEmail}
                onClick={() => {
                  const newValue = !checkboxValues.phoneOrEmail;

                  setCheckboxValues({
                    ...checkboxValues,
                    phoneOrEmail: newValue,
                    phone: newValue ? false : checkboxValues.phone,
                    email: newValue ? false : checkboxValues.email,
                  });
                }}
              /> */}
              {(addToListWithOptionsState.addToListData
                .showBuyMoreCreditsWarning ||
                addToListWithOptionsState.addToListData
                  .showNotEnoughCreditsWarning) && (
                <div className="credits-error-wrapper">
                  <div className="warning-icon-wrapper">
                    <WarningIcon />
                  </div>
                  <div className="text-wrapper">
                    <p>
                      {checkboxValues.email &&
                      checkboxValues.phone &&
                      selectedCount > availablePhoneCredits &&
                      selectedCount > availableEmailCredits
                        ? "You don't have enough email & phone credits"
                        : checkboxValues.email &&
                          selectedCount > availableEmailCredits
                        ? "You don't have enough email credits"
                        : checkboxValues.phone &&
                          selectedCount > availablePhoneCredits
                        ? "You don't have enough phone credits"
                        : ''}
                    </p>
                    <p>
                      To proceed with the purchase, either increase your credit
                      balance or adjust your selection accordingly
                    </p>
                  </div>
                </div>
              )}
              <div className="button-wrapper">
                <Button
                  btnText="Cancel"
                  className="cancel-btn"
                  click={() => handleCloseClick()}
                />
                {addToListWithOptionsState.addToListData
                  .showBuyMoreCreditsWarning ? (
                  <Link
                    className="buy-more-credits"
                    to={PAGE_PATH_MAP.BUY_MORE_CREDITS}
                    onClick={() => handleCloseClick()}
                  >
                    Buy more credits
                  </Link>
                ) : addToListWithOptionsState.addToListData
                    .showNotEnoughCreditsWarning ? (
                  <Link
                    className="buy-more-credits"
                    to={PAGE_PATH_MAP.PRICING}
                    onClick={() => handleCloseClick()}
                  >
                    Upgrade Now
                  </Link>
                ) : (
                  <Button
                    className="save-btn"
                    btnText="Save"
                    loader={addToListloading}
                    click={handleSaveClick}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </HocPopupComponent>
    )
  );
});

export { AddToListWithOptions, addToListWithOptionsState };
